import { render, staticRenderFns } from "./design_purchaseorder.vue?vue&type=template&id=4da69bd8"
import script from "./design_purchaseorder.vue?vue&type=script&lang=js"
export * from "./design_purchaseorder.vue?vue&type=script&lang=js"
import style0 from "./design_purchaseorder.vue?vue&type=style&index=0&id=4da69bd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports